const TheCatCameBack = [
	'Old Mr. Johnson had troubles of his own',
	"He had a yellow cat that wouldn't leave his home",
	'He tried and he tried to give the cat away',
	'He gave it to a man going far far away',
	'',
	'But the cat came back, the very next day',
	'The cat came back',
	'(they thought he was a goner)',
	"but the cat came back, he just couldn't stay",
	'Away away away',
	'MEOW!',
	'',
	'So he gave it to a woman going',
	'Up in a balloon',
	'He told her for to take it to the',
	'Man up in the moon',
	'The balloon came down about',
	'90 miles away',
	'and where the woman is now,',
	'well I cannot say',
	'',
	'but the cat came back…',
	'',
	'so he gave it to a man going way out West',
	'he told him for to take it to the one he loved the best',
	'first the train hit the track,',
	'then it jumped the rail',
	'and nobody was left to tell the awful tale',
	'',
	'But the cat came back…',
];

export default TheCatCameBack;
